import './index.scss';



/** WEBPACK FOOTER **
 ** ./src/Category/index.js
 **/